<template>
  <div>
    <button type="button" class="btn btn-cyan flex-item" @click="show = true">
      <i class="fa fa-plus"/>
      Create
    </button>
    <modal-new :out-side-dimiss="false" v-model="show" title="Create new design">
      <add-new-e-m-b-form  @success="hide(); $emit('success')"/>
    </modal-new>
  </div>
</template>

<script>
import DesignAssignForm from "@/components/Views/Design/DesignAssignForm";
import Modal from "@/components/Misc/Modal";
import AddNewEMBForm from "@/components/Views/Order/AddNewEMBForm";
import ModalNew from "@/components/Common/ModalNew";

export default {
  name: "DesignCreateButton",
  components: {ModalNew, AddNewEMBForm, Modal, DesignAssignForm},
  props: {value: Object},
  data() {
    return {
      show: false
    }
  },
  methods: {
    hide() {
      this.show = false;
    }
  }
}
</script>